import axios from 'axios';
import { AppUrls, } from './Globals';
import { Config } from './Config';

export const fileMasiveRequests = {}//Objeto agrupador de funciones

fileMasiveRequests.GetSignatureRequestsByUsuario = (data) => {
  console.log('GetSignatureRequestsByUsuario', data )
  return axios.post(
    AppUrls.GetSignatureRequestsByUsuario,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

fileMasiveRequests.UploadBatchSign = (data) => {
  return axios.post(
    AppUrls.UploadBatchSign,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

let handleResponse = (response) => {
  console.log('ResponseMasive', response )
  let respObject = response.data;
  if (!respObject.IsOK) {
    let responseObject = { message: respObject.Messages + ' ' + (respObject.TansactionId ? respObject.TansactionId : '') + ' ' + (respObject.statusText ? respObject.statusText : '') };
    let error = (respObject.Body || responseObject);
    return Promise.reject(error);
  }
  return respObject;
}